<template>
    <div id="app">
        <header class="tw-container tw-flex tw-items-center tw-justify-center md:tw-justify-start">
            <img src="~@/assets/img/logo.svg" alt="Rougier & Plé">
        </header>

        <!-- This will be reaplced by the view defined in the router -->
        <router-view v-if="$store.state.google"/>

        <CookiesConsent />
    </div>
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader';
import CookiesConsent from '@/components/CookiesConsent.vue';

export default {
    components: {
        CookiesConsent,
    },
    async mounted() {
        const googleMapApi = await new GoogleMapsApiLoader({
            apiKey: 'AIzaSyAyQG_7zjZFPaIHyzb5dR7fKcACfyCTPf0',
            libraries: ['places'],
            region: 'FR',
            language: 'fr-FR',
        });

        this.$store.state.google = googleMapApi;
    },
};
</script>
<style lang="scss" scoped>
header {
    height: 75px;

    img {
        max-width: 155px;
        width: 100%;
        height: auto;

        @screen md {
            max-width: 200px;
        }
    }
}

</style>
